import React from 'react';
import { bool, number, string } from 'prop-types';
import classNames from 'classnames';
import { Rating } from '@fiverr-private/orca';
import { getContext } from '@fiverr-private/fiverr_context';
import { createClickedElement } from '../../../utils';
import { ELEMENTS_NAME, ELEMENTS_TYPE } from '../../../Components/constants';
import { getRatingPrecision } from '../../../../utils/ratingPrecision';
import { getCount } from './utils';

import styles from './index.module.scss';

const GigRating = ({ hasRating, score, count, className, scoreClassName, countClassName }) => {
    const { abTests = {} } = getContext();
    const { minimumFractionDigits, maximumFractionDigits } = getRatingPrecision(score, abTests);
    const scorePrecisionProps = {
        scoreMinimumFractionDigits: minimumFractionDigits,
        scoreMaximumFractionDigits: maximumFractionDigits,
    };
    return (
        <div className={classNames('m-t-8', 'flex', styles.ratingContainer, className)}>
            {hasRating && (
                <Rating
                    score={score}
                    ratingsCount={getCount({ count })}
                    color={Rating.COLORS.BLACK}
                    theme={Rating.THEMES.ONE_STAR}
                    showScore={hasRating}
                    className={styles.rating}
                    scoreClassName={classNames(styles.score, scoreClassName)}
                    starClassName={styles.star}
                    ratingsCountClassName={classNames(styles.count, countClassName)}
                    {...scorePrecisionProps}
                />
            )}
        </div>
    );
};

GigRating.propTypes = {
    count: number,
    className: string,
    scoreClassName: string,
    countClassName: string,
    score: number,
    hasRating: bool,
};

export default GigRating;

export const clickedElement = (score) => createClickedElement(ELEMENTS_NAME.RATING, ELEMENTS_TYPE.LINK, score);
